import { render, staticRenderFns } from "./default-language.vue?vue&type=template&id=33ee3dc3&scoped=true"
import script from "./default-language.vue?vue&type=script&lang=js"
export * from "./default-language.vue?vue&type=script&lang=js"
import style0 from "./default-language.vue?vue&type=style&index=0&id=33ee3dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee3dc3",
  null
  
)

export default component.exports